import React, { Component } from 'react';

class LineBreak extends React.Component {
    render() {
        return (
            <br />
        );
    }
}


export default LineBreak;
